<template>
  <div>

    <card class="card" title="Procesar un archivo de pago">
    
    <stepper :options="stepperOptions" :beforeNext="beforeNext" :beforePrev="beforePrev">

      
        <div slot="step-1">
            <h3>Archivo de pago</h3>
            <div class="form-group">
              <b-alert v-if="errors" :variant="message_type" v-html="message" show></b-alert>
              <label for="archivoPago">Selecciona el archivo de pago en formato .txt y presiona "Siguiente"</label>
              <input class="form-control" required type="file" ref="archivoPago" id="archivoPago" v-on:change="seleccionarArchivoPago" name="pago" accept=".txt"/>
            </div>
      
        </div>
        
        <div slot="step-2">
            <h3>Archivos de control</h3>
            <label for="archivoControl">Sube el o los archivos de control señalados en formato CSV</label>
            <b-alert v-if="control_files" :variant="'info'" v-html="control_files_string" show></b-alert>
            <b-alert v-if="errors_c" :variant="message_type_c" v-html="message_c" show></b-alert>
            <label v-if="skip_missing"><input type="checkbox" v-model="skip_missing_value" ref="skip_missing" value="1"/> Omitir estos registros</label>

            <div class="form-group">
            <input id="archivoControl" ref="archivosControl" class="form-control" required type="file" v-on:change="seleccionarArchivoControl" name="control" multiple accept=".csv"/>
          </div>

            
        </div>
        
        <div slot="step-3">
      
            <div class="results" v-if="show_results">
              <a v-bind:href="download_link" target="_blank" class="pull-right"><i class="ti-download"></i>Descargar {{ filename }}</a>
              <h3>Resultados</h3>

              <b-table
                id="my-table"
                :items="items"
                :per-page="perPage"
                :current-page="currentPage"
                small
              ></b-table>
                
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              ></b-pagination>

              <p class="mt-3">Página: {{ currentPage }}</p>
              
              <h4>Utilidad total: ${{ utilidad_total }}</h4>

            </div>

        </div>
        
    </stepper>

  </card>

<!--

    <card class="card" title="Procesar un archivo de pago">

      <p>Para calcular la utilidad necesitas subir el(los) archivo(s) de control y el archivo de pago de Amazon</p>
      <form @submit.prevent="procesarArchivos">
      <div class="form-group">
        <label for="archivoControl">Sube uno o múltples archivos de control en formato CSV</label>
        <input id="archivoControl" class="form-control" required type="file" v-on:change="seleccionarArchivoControl" name="control" multiple accept=".csv"/>
      </div>
      <div class="form-group">
        <label for="archivoPago">Archivo revisado</label>
        <input class="form-control" type="file" id="archivoRevisado" v-on:change="seleccionarArchivoRevisado" name="pago" accept=".csv"/>
      </div>

      <b-alert v-if="errors" :variant="message_type" v-html="message" show></b-alert>

      <button class="btn btn-info" round>{{estatus}}</button>
    




  </div>    


      
      

      </form>
     </card>
    -->

  </div>
</template>
<script>




import api from '@/util/api.js';
import Stepper from '@/components/stepper';

export default {
  components: {
    Stepper
  },

  computed:{

    
      rows() {
        return this.items.length
    },

    message_type(){

      return this.msg_type

    },
    message_type_c(){

      return this.msg_type_c

    },

    estatus(){

      
        return this.loading?'Procesando...':'Procesar archivo';


    },

    show_results(){

      return this.has_results;

    }


  },

  data() {
    return {


      nText:'Siguiente',
      stepperOptions: {
        headers: [
          {title: 'Archivo de pago'},
          {title: 'Archivos de control'},
          {title: 'Resultados'},
        ],
        prevText: 'Anterior',
        nextText: 'Siguiente',
        disabled:false
      },

      skip_missing:false,
      skip_missing_value:0,
      has_results:false,
      filename:'',
      download_link:'',
      errors:false,
      message:'',
      msg_type:'',
      errors_c:false,
      message_c:'',
      msg_type_c:'',
      loading:false,
      utilidad_total:'',
      model:{
        control:[],
        pago:'',
        revisado:''
      },
      control_files:false,
      control_files_string:'',
      perPage: 50,
      currentPage: 1,
      items: []



    }
  },

  methods:{


    async beforeNext(current){



      if(current==0){

        
        return this.validarArchivoPago();

      }else if(current==1){

        return this.procesarArchivo();

      }


        return false;



    },

    beforePrev(current){
      return new Promise((resolve, reject) => {
        resolve(true);
      });

    },


    async validarArchivoPago(){


      if(this.model.pago){
              this.stepperOptions.disabled=true;
              this.stepperOptions.nextText='Preparando...';

              const data=new FormData;

              data.append('pago',this.model.pago);

              const params = {
                        onUploadProgress: event => {

    
                            const uploadprogress = parseInt(Math.round((event.loaded * 100) / event.total));

                            

                            if(uploadprogress<100){
                              this.stepperOptions.nextText='Subiendo archivo '+uploadprogress+'%';
                            }else{
                              this.stepperOptions.nextText='Analizando...';
                            }

                        },

                        //headers:{'Content-type':'form/data'}
                    };



              return await api.post('/uploader/preprocess',data,params).then(response=>{

                

                if(response.data.done){              

                  let str_files='';
                  this.errors=false;
                  const filenames=response.data.control_files;
                  for(let i in filenames){
                    this.control_files=true;
                    
                    str_files+=filenames[i]+'<br>';
                  }


                  this.control_files_string=str_files;

                  return true;
                }else{
                  this.message=response.data.message;
                  this.msg_type='danger';
                  this.errors=true;
                  return false;
                }

              }).finally(()=>{
                    this.stepperOptions.disabled=false;
                    this.stepperOptions.nextText='Siguiente';
                    this.$refs.archivoPago.value="";

              });



          }else{
            alert('No has seleccionado el archivo');
          }



    },


    async procesarArchivo(){



      
      if(this.model.control.length>0){

          this.stepperOptions.disabled=true;
          this.stepperOptions.nextText='Preparando...';
          this.has_results=false;
          const data=new FormData();
          data.append('pago',this.model.pago);
          data.append('revisado',this.model.revisado);

          for (var i = 0; i < this.model.control.length; i++) {
              data.append('control[]', this.model.control[i]);
          }

          this.loading=true;

          this.errors=false;


      const config={

        onUploadProgress:(event)=>{

          const uploadprogress = parseInt(Math.round((event.loaded * 100) / event.total));

          if(uploadprogress<100){
            this.stepperOptions.nextText='Subiendo archivo(s) '+uploadprogress+'%';
          }else{
            this.stepperOptions.nextText='Procesando...';
          }

        }

      }


      return await api.post('/uploader?skip_missing='+(this.skip_missing_value?'1':'0'),data,config).then(response=>{

      
              if(response.data.done){
                this.items=response.data.items;
                this.filename=response.data.filename;
                this.download_link=response.data.download_link;
                this.utilidad_total=response.data.utilidad_total;
                this.has_results=true;

                return true;

              }else{
                this.message_c=response.data.message;
                if(response.data.not_found){

                  this.skip_missing=true;

                  let skus='';
                  for(let i in response.data.not_found){
                      skus+=response.data.not_found[i]+"<br>";
                  }

                  this.message_c+='.<br> Los SKU no encontrados son:<br>'+skus;

                }
                this.msg_type_c='danger';
                this.errors_c=true;


                return false;

              }



                
              }).catch(error=>{

              console.log(error);
              }).finally(()=>{

              this.loading=false;

              this.stepperOptions.disabled=false;
              this.stepperOptions.nextText='Siguiente';

              this.$refs.archivosControl.value="";

              });


            }else{
              alert('No subiste los archivos');
              
            }

          


    },


    seleccionarArchivoControl(event){

      this.model.control = event.target.files;
    },
    seleccionarArchivoRevisado(event){

      this.model.revisado = event.target.files;
    },

    seleccionarArchivoPago(event){

      this.model.pago = event.target.files[0];
    },


  }


};
</script>
<style></style>
